var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable, override } from 'mobx';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class SortableScore extends QuestionScore {
    manifestedPoints = -1;
    manifestedOverallState;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return Math.max(3, this.question.sortableStore.sortableItems.length * 0.5);
    }
    get reachedPoints() {
        if (this.manifestedPoints > -1)
            return this.manifestedPoints;
        return Math.max(this.question.sortableCheck.numberOfItemsInAnyCorrectPlace * 0.5, 3);
    }
    get progressiveReachablePoints() {
        return this.reachedPoints;
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        if (this.question.answer.completeDate)
            return false;
        if (this.question.answeringState.currentAnswerState !== QuestionAnswerState.Answering)
            return false;
        if (this.question.sortableCheck.isSortableMatchingAnySuccessState)
            return true;
        if (this.question.sortableMoves.movesRemaining <= 0)
            return true;
        if (this.question.sortableStore.sortableLists[0].listItems.currentSortableItems.length === 0)
            return true;
        return false;
    }
    get legacyEvalText() {
        return '';
    }
    set legacyEvalText(t) { }
}
__decorate([
    observable
], SortableScore.prototype, "manifestedPoints", void 0);
__decorate([
    observable
], SortableScore.prototype, "manifestedOverallState", void 0);
__decorate([
    override
], SortableScore.prototype, "maxPoints", null);
__decorate([
    override
], SortableScore.prototype, "reachedPoints", null);
__decorate([
    override
], SortableScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], SortableScore.prototype, "shouldSetCompletedTimestamp", null);
